import { type FeatureModule } from '@store/features/types';
import storage from 'redux-persist/lib/storage'; // localStorage

import { encountersApi } from './api';
import { workflowOnlyIdTransform } from './workflowPersistTransform';
import encounterWorkflowReducer from './workflowSlice';

/**
 * Encounters feature module definition
 */
export const encountersFeature: FeatureModule = {
  // Basic feature identification
  id: 'encounters',
  name: 'Encounters',

  // Feature dependencies (if any)
  dependencies: [], // No dependencies

  // Feature reducers
  reducers: {
    'encounters/workflow': encounterWorkflowReducer,
  },

  // No additional middleware (API middleware is registered globally via baseApi)
  middleware: [],

  // Persistence configuration
  persistence: {
    enabled: true,
    storage: storage, // localStorage
    version: 2, // Bumped from 1 to support scoped persistence
    transforms: [workflowOnlyIdTransform], // Only persist activeWorkflowEncounterId
    debounce: 500, // Debounce writes to localStorage
    migrations: {
      // Migration from v1 to v2: trim state to only activeWorkflowEncounterId
      2: (state: any) => {
        if (state?.workflow) {
          return {
            ...state,
            workflow: {
              activeWorkflowEncounterId: state.workflow.activeWorkflowEncounterId ?? null,
            },
          };
        }
        return state;
      },
    },
  },

  // Cross-tab sync configuration
  sync: {
    enabled: true,
    whitelist: [
      'encounters/workflow/setActiveWorkflowEncounter',
      'encounters/workflow/clearActiveWorkflowEncounter',
    ],
  },

  // Feature lifecycle hooks
  setup: _store => {
    // Setup code when feature is registered
    // Avoid console.log in production
  },

  cleanup: _store => {
    // Cleanup code when feature is unregistered
  },
};

/**
 * Initialize feature - call this when registering the feature
 */
export function initializeEncountersFeature() {
  return {
    api: encountersApi,
    feature: encountersFeature,
  };
}
